import type { FaireProductEntity } from "../../entity_types/product";

export const p_4vapkv9ftw: FaireProductEntity = {
  token: "p_4vapkv9ftw",
  type: "product",
  name: "French Terry Balloon Pants (2S-2M-2L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/5f03ce4bf9058cec3782ae2372aae31c93cda431dfcfbfdf2891d21d57a6cebf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8192a57f26eda6632565c6b362ae69d89a19a2f9ba659d55a81fe062e6b5c824.jpeg",
    "https://cdn.faire.com/fastly/6c38f06220e93358e0bdf56183a3b49e4fdd6bfbb35daec9a57548ce27e0d7f4.jpeg",
    "https://cdn.faire.com/fastly/96fa0dbf5aa38e2b67d4a67a0e33aa4ffa208fcb1450e303b1d71e4c9dbb1b6e.jpeg",
    "https://cdn.faire.com/fastly/f4731ce0a586ca1784513fbbd1b6642dfcb5a255f09a45e57cb0835b21b6da03.jpeg",
    "https://cdn.faire.com/fastly/61ec4ad6cbdb915852af5755be078442dab685f7298b5d0d11d53e4e9a0ff5c5.jpeg",
    "https://cdn.faire.com/fastly/c9131b631d8560df45e9576ed018282dfdec8d84ff03441cc26654d5ae958c86.jpeg",
    "https://cdn.faire.com/fastly/14dffcbc4195b78b65b8de35713c6530a242959806151777e8cc6fe57d9c0914.jpeg",
    "https://cdn.faire.com/fastly/d73c84b1a8ff67e1b4147ff2b1c096a61716c88b1434f9fa9de5b58cfa4eab46.jpeg",
    "https://cdn.faire.com/fastly/d6a7fd97c0293b193960b7bf4daeb7b8b4f0e85edfc2a82720d5ef04ee179125.jpeg",
    "https://cdn.faire.com/fastly/2e23bd11758709e39190f7e8cd4cf7d0ac4997e2540644523664f440b97c1a34.jpeg",
    "https://cdn.faire.com/fastly/5881cb034c4f33bb6cbe3e54dac5e9d6a647d04e5e5f0c1b051dc6603f7dbbdd.jpeg",
    "https://cdn.faire.com/fastly/6f7cfe2fb16df254dfba59124ac2745767645e943a26985de977c8efc86ca969.jpeg",
    "https://cdn.faire.com/fastly/578be568fb7f63f856e2a9059b22bf4c6150fca67e1f34bf4a982ded9323304d.jpeg",
    "https://cdn.faire.com/fastly/2fa5f1a5dddb45c5a92b36e8893ac9b409b7f12ab180a6306465ddc3711b0611.jpeg",
    "https://cdn.faire.com/fastly/e9d9cad415641a0362a316b83830cc5d17b9dc8316d089e21fbd8dbfdbfbdebf.jpeg",
    "https://cdn.faire.com/fastly/efda148e901f455482487945daa5c8d99023e79958f4c23765a5e2b47fc3d76a.jpeg",
    "https://cdn.faire.com/fastly/65df045fd2f6f56b368625816b0f2ce3749f2b51238391be6ff3fb9d4843afe0.jpeg",
  ],
  priceDollars: 330,
  description:
    'Why We Made This?\n\nIntroducing our beloved heavier balloon pants, the ultimate comfort companions for those chilly days! We\'ve all felt that longing for our cherished balloon pants when the weather turns colder, so we took matters into our hands and crafted them in cozy French Terry fabric! They feature thoughtful design details like an elastic leg opening, a comfortable elastic high waist, slimming side panels and hidden side slit pockets. The ideal knit pant yet comfier than pajamas, these pants will be your new uniform for lounging, in-office, running around town and even the great outdoors.\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n100% Cotton\n\nMade in South Korea\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Washing these garments only with like colors and in cold water\n• Recommend to Hang Dry for the best result!\n\n𝐀𝐩𝐩𝐫𝐨𝐱𝐢𝐦𝐚𝐭𝐞 𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\n\nSmall: Waist 12" relaxed, Inseam 26"\n\nMedium: Waist 13" relaxed, Inseam 26 1/4"\n\nLarge: Waist 14" relaxed, Inseam 26 1/2"\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size small\n\nMSRP: $110 USD',
  tags: [],
  msrpDollars: 660,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:55.424Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
